export default class Description extends React.Component {
  constructor(props) {
    super(props);
    this.buildCharacteristicString = this.buildCharacteristicString.bind(this);
  }

  buildCharacteristicString(key, value, translation, unit) {
    const formattedValue = value > 0 ? `${value} ${unit}` : null;
    return formattedValue ? (
      <div key={key} dangerouslySetInnerHTML={{ __html: `${translation}: ${formattedValue}` }} />
    ) : null;
  }

  render() {
    const translations = {
      length: 'Длина',
      basin_area: 'Бассейн',
      max_depth: 'Максимальная глубина',
      shoreline_length: 'Береговая линия'
    };

    const units = {
      length: 'км',
      basin_area: 'км<sup>2</sup>',
      max_depth: 'м',
      shoreline_length: 'км'
    };

    const characteristicsArray = Object.entries(this.props.characteristic || {}).map(
      ([key, value]) => this.buildCharacteristicString(key, value, translations[key], units[key])
    );

    const isActiveClassLink = this.props.active_post_page_status ? '-link' : '';
    const isActiveClassCampsLink = this.props.active_status ? 'link under under_line before-ico before-ico_arrow before-ico_arrow_green' : '';

    return (
      <div className="card__sight-info">
        <a className={`card__sight-header-name${isActiveClassLink}`}
           href={this.props.active_post_page_status ? this.props.water_url : null}
           target="_blank">
          <h3 className="card__title">
            {this.props.name}
          </h3>
        </a>

        <div className="card__sight-characteristic text_gray">
          {characteristicsArray.filter(Boolean).map((characteristic, index) => (
            <div key={index}>{characteristic}</div>
          ))}
        </div>

        <div className="camps-link">
          <a href={this.props.data.seo_path}
             className={`camps-link-text ${isActiveClassCampsLink}`}>
            {this.props.count_variants}
          </a>
        </div>

        <div className="card__sight-description">
          <div className="card__sight-description-text text_gray">
            {this.props.short_description}
          </div>
        </div>

        {this.props.active_post_page_status && (
          <div className="card__sight-actions">
            <a href={this.props.water_url}
               rel="nofollow"
               target="_blank"
               className="btn-more typography-normal"
            >
              Подробнее
            </a>
          </div>
        )}
      </div>
    )
  }
}
